import React from "react";
import { AllRunningTotalChartsRes } from "src/store/features/api/generated";
import { RangeSwitchOpts } from "./dashboardChart.types";

// Define interface for formatted data
export interface IFormattedData {
  time: string; // Represents the time of the data point
  value: number; // Represents the value associated with the data point
}

export interface CryptoData {
  x: (string | null)[]; // Array of timestamps or null values
  yLine: number[]; // Array of corresponding values
}

// Custom hook to format chart data
const useFormatBalanceData = (
  data: AllRunningTotalChartsRes | CryptoData | undefined, // Data input for formatting
  selectedDuration: RangeSwitchOpts, // Selected duration for formatting
) => {
  const [formattedData, setFormattedData] = React.useState<IFormattedData[]>([]); // State variable to store the formatted data

  React.useEffect(() => {
    if (data) {
      const transformData = () => {
        if ("yLine" in data) {
          // Handle CryptoData, often from BTC and ETH endpoint
          const filteredData = data.x.reduce((acc: IFormattedData[], dateString, index) => {
            // Filter out null values
            if (dateString !== null) {
              acc.push({ time: dateString, value: data.yLine[index] }); // Add formatted data point to accumulator array
            }
            return acc;
          }, []);

          // Set the formatted data for CryptoData
          setFormattedData(filteredData);
        } else {
          // Handle AllRunningTotalChartsRes
          const stacks = data[selectedDuration]; // Get the stacks data for the selected duration
          if (stacks) {
            // Flatten and transform data for AllRunningTotalChartsRes
            const formatted: IFormattedData[] = [];

            for (const [index, timestamp] of stacks[0].axes.x.entries()) {
              formatted.push({
                time: timestamp,
                value: stacks[0].axes.y[index],
              }); // Add formatted data point to array
            }
            const sortedFormattedData = formatted.sort((a: any, b: any) => a.time - b.time);

            // Set the formatted data for AllRunningTotalChartsRes
            setFormattedData(sortedFormattedData);
          }
        }
      };

      transformData(); // Call the data transformation function
    }
  }, [data, selectedDuration]); // Run the effect whenever the data or selected duration changes

  return { data: formattedData }; // Return the formatted data object
};

export default useFormatBalanceData;
